import { ActionButton } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { routes } from "../../../config/routes";

type Props = {
  isActive?: boolean;
};

const SharedLicensePlateBtn = ({ isActive }: Props) => {
  const { fleetId } = useParams() as any;
  const { t } = useTranslation();

  return (
    <Link to={routes.sharedLicensePlate.getPath(fleetId)}>
      <ActionButton
        styles={{
          root: {
            fontWeight: isActive ? "bold" : "inherit",
          },
        }}
        iconProps={{
          iconName: "AnalyticsReport",
          styles: {
            root: {
              fontWeight: isActive ? "bold" : "inherit",
            },
          },
        }}
        text={t("bfm.sharedLicensePlate")}
      />
    </Link>
  );
};

export default SharedLicensePlateBtn;
